'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('../common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('../common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('../common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'Online Contract SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'Sign Online Contracts',
            subtitle: 'Ready to starting signing? Create a free account to send your first signature request.',
            buttonText: 'CREATE MY ACCOUNT'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },
    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _react2['default'].createElement(
            _bodySection2['default'],
            null,
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'How can I sign online contracts with HelloSign?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'HelloSign eSignatures can be used to sign all types of contracts, from informal agreements to enterprise sales deals. Our electronic signatures remove the need for printing, signing, scanning, and faxing, making it simple to sign a contract online at any time.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Here are just a few examples of contracts that are signed using eSignatures:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Sales contracts'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Freelance contracts'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Real estate leases'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'And more!'
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Is it legal to sign online contracts?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Yes! Electronic signatures are a legally-binding and federally protected way to sign online contracts and documents. eSignatures have been recognized in the USA since 2000 under the ESIGN Act. Internationally, eSignatures are protected under country and region specific laws including the Electronic Signatures Directive in the EU.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'For more information about what documents are legal, you can check out our blog post on ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'http://blog.hellosign.com/esignatures-legal-handwritten-signatures/',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'eSignature legality here'
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'How does HelloSign work?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'HelloSign is a desktop and device-friendly app that gives you the power to format online contracts with text fields, request electronic signatures for online contracts, keep a detailed audit-trail for every document, and securely store signed documents in your account. We provide technology that complies with current eSignature law and standards.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'We\u2019ve been around since 2010 and have grown tremendously over the past few years!'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What does an online contract signing flow look like?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'You can start signing online contracts soon as you create a HelloSign account. Here\u2019s a peek at what a signing flow looks like:'
            ),
            _react2['default'].createElement(
                'ol',
                null,
                _react2['default'].createElement(
                    'li',
                    null,
                    'Upload the sales contract you\u2019d like to sign or send.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Use text boxes, signature boxes, or date boxes to format the appropriate fields in your document.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Enter in recipient contact info (email) and add a personal message to recipients. '
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Click "Request Signature."'
                )
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Once you\u2019ve sent your signature request, you\u2019ll receive automatic email reminders until the document has been signed. These reminders make it easy to keep track of any online contract you have out for signature so you don\u2019t lose a deal or a document in the cracks.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Bonus: All HelloSign\u2019s signing flows feature a device-optimized signer experience, so you can sign easily from your mobile phone or tablet.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What other features are useful for someone wanting to send or sign online contracts?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'In addition to the basic features of HelloSign, there are other key features for anyone looking to sign an online contract. These features were all created to make it easier and more efficient to organize signing order and flow of a contract:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Signer permissions.'
                    ),
                    ' Two-factor authentication is a protection tool that requires a signer to enter a unique code before accessing your document. This is particularly useful for highly-sensitive docs!'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Signer order.'
                    ),
                    ' Got more than one person signing a doc? You can assign a signing order to make sure the right fields are filled out in the right order.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Data validation.'
                    ),
                    ' To protect against signer typos, you can set rules for your text fields. For example, you can set a \u201Cnumbers only\u201D rule for a phone number text field. A signer will receive an error if they enter in characters other than a number.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Templates.'
                    ),
                    ' This features allows you you create a reusable template for your frequently used documents. You just have to format the document once, save a template, and then you can access the formatting again and again!'
                )
            )
        );
    },
    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get Started',
            subtitle: 'It\'s easy to start signing your online contracts! Click below to set up your free account now or click on “See Plans” to see options for unlimited documents and templates.',
            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            null,
            this.renderTitleSection(),
            this.renderBodySection(),
            this.renderCTASection()
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/online-contract.jsx
 ** module id = 1219
 ** module chunks = 0
 **/